import { Instance, SnapshotOut, types } from 'mobx-state-tree';

/**
 * # Appendix
 *
 * Appendix을 설명하세요.
 */
export const Appendix = types
  .model('Appendix')
  // --------------------------------------------------------------------------
  .props({
    appendixSid: types.identifierNumber,
    appendixNm: types.maybeNull(types.optional(types.string, '')),
    appendixContent: types.maybeNull(types.optional(types.string, '')),

    reportSid: types.optional(types.number, 0),

    insertDt: types.optional(types.number, 0),
    updateDt: types.optional(types.number, 0),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model appendix --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: IAppendix }) => {
      const newProps = { ...self, ...props } as IAppendix;
      (Object.keys(newProps) as TAppendixKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TAppendix = Instance<typeof Appendix>;
type TAppendixSnapshot = SnapshotOut<typeof Appendix>;

export interface IAppendix extends TAppendix {}
export type TAppendixKeys = keyof TAppendixSnapshot & string;
export interface IAppendixSnapshot extends TAppendixSnapshot {}
export const createAppendix = () => types.optional(Appendix, { appendixSid: 0 } as TAppendix);
